import { Message, ProtobufMessageClass } from '@ms/yammer-protobuf';

import { ReportAnalyticsEvent } from './usageV2';

export const MockedProtobufEventV1: ProtobufMessageClass<Message> = {} as unknown as ProtobufMessageClass<Message>;

export const mockedReportAnalyticsEvent: ReportAnalyticsEvent = (_MessageClass, _plainMessage, _loggingOptions) =>
  Promise.resolve();
